import { makeStyles } from "@material-ui/core";

export const singleCardsStyles = makeStyles((theme) => ({
  root: {
    minHeight: 500,
    borderRadius: "15px 0 0 15px",
    backgroundColor: theme.palette.secondary.backgroundLight,
    padding: "40px 100px 50px 80px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      borderRadius: "15px",
      minHeight: "auto",
      paddingLeft: "10%",
      paddingRight: "10%",
    },
  },
  box: {
    backgroundColor: theme.palette.common.white,
    boxShadow: "0 2px 12px 0 rgba(0,0,0,0.02), 0 10px 30px 0 rgba(0,0,0,0)",
    padding: "48px 57px 38px 57px",
    alignItems: "flex-start",
    marginBottom: 46,
    [theme.breakpoints.down("sm")]: {
      padding: 32,
      marginBottom: 0,
    },
  },
  boxText: {
    marginBottom: 20,
    fontWeight: 300,
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    letterSpacing: "0.5px",
    textAlign: "center",
    width: 192,
    "&:last-child": { marginLeft: 20 },
    "&:first-child": { backgroundColor: "transparent" },
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));
